import { createFileRoute } from '@tanstack/react-router';
import { OrganizationProfile } from '@uturn/portal/modules/org/pages/profile';

export const Route = createFileRoute('/_protected/org/$orgId/settings/')({
	component: OrganizationProfile,
});
